import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../../../ui/card";
import { Input } from "../../../ui/input";
import { Label } from "../../../ui/label";
import { RocketIcon } from "lucide-react";

interface FinetuneDetailsStepProps {
  displayName: string;
  setDisplayName: (value: string) => void;
  description: string;
  setDescription: (value: string) => void;
  isExporting: boolean;
}

const FinetuneDetailsStep: React.FC<FinetuneDetailsStepProps> = ({
  displayName,
  setDisplayName,
  description,
  setDescription,
  isExporting,
}) => {
  return (
    <div className="space-y-8">
      {/* Header */}
      <div className="text-center space-y-3">
        <h2 className="text-2xl font-gc-demi-bold text-foreground">
          Finetune Details
        </h2>
        <p className="text-muted-foreground font-gc-reg">
          Enter a name and description for your finetune run
        </p>
      </div>

      {/* Form Card */}
      <Card className="border-border">
        <CardHeader className="pb-4">
          <CardTitle className="flex items-center gap-2 text-lg font-gc-med text-foreground">
            <RocketIcon className="w-5 h-5 text-maitai-green" />
            Basic Information
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="space-y-3">
            <div className="flex items-center gap-2">
              <Label htmlFor="finetune-name" className="text-sm font-gc-med text-foreground">
                Display Name
              </Label>
              <span className="text-red-500 text-sm">*</span>
            </div>
            <Input
              id="finetune-name"
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
              placeholder="Enter a name for this finetune run"
              className="w-full"
              disabled={isExporting}
            />
            <p className="text-xs text-muted-foreground">
              A unique name for your finetune run
            </p>
          </div>

          <div className="space-y-3">
            <div className="flex items-center gap-2">
              <Label htmlFor="finetune-description" className="text-sm font-gc-med text-foreground">
                Description
              </Label>
            </div>
            <textarea
              id="finetune-description"
              value={description}
              onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setDescription(e.target.value)}
              placeholder="Enter description (optional)"
              rows={4}
              disabled={isExporting}
              className="flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
            />
            <p className="text-xs text-muted-foreground">
              Optional description for the finetune run
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default FinetuneDetailsStep; 